/** "What this package includes" card — included hours, then who may teach the package. */

import { IncludedIcon } from '@butter/ui/icons';
import { formatLessonHoursSentence, type LessonInstructorRef } from '~/services/internalApi/lessons';
import { LessonInstructorChips } from './LessonInstructorChips';

const NO_INSTRUCTORS: readonly LessonInstructorRef[] = [];

export interface LessonIncludesCardProps {
  maxTotalMinutes: number | null;
  instructors?: readonly LessonInstructorRef[];
  className?: string;
}

export function LessonIncludesCard({ maxTotalMinutes, instructors = NO_INSTRUCTORS, className = '' }: LessonIncludesCardProps) {
  const headingId = 'lesson-includes-heading';
  const instructorsLabelId = 'lesson-includes-instructors-label';

  return (
    <section aria-labelledby={headingId} className={`flex flex-col gap-6 rounded-28 border-1.25 border-butter-gray-200 bg-butter-gray-25 p-7 ${className}`}>
      <h2 id={headingId} className="text-xl font-semibold leading-6 text-butter-gray-800">What this package includes</h2>
      <ul className="flex flex-col gap-5">
        <li className="flex items-start gap-2">
          <IncludedIcon aria-hidden className="mt-px size-4.5 shrink-0 text-butter-gray-700" />
          <div className="flex flex-col gap-1">
            <p className="text-base font-semibold leading-5 text-butter-gray-900">{formatLessonHoursSentence(maxTotalMinutes)}</p>
            <p className="text-sm font-medium leading-tight text-butter-gray-700">Use your package hours when booking lessons</p>
          </div>
        </li>
        {instructors.length > 0 && (
          <li data-testid="lesson-includes-instructors" className="flex items-start gap-2">
            <IncludedIcon aria-hidden className="mt-px size-4.5 shrink-0 text-butter-gray-700" />
            <div className="flex flex-col gap-1.5">
              <p id={instructorsLabelId} className="text-base font-semibold leading-5 text-butter-gray-900">Available instructors</p>
              <LessonInstructorChips instructors={instructors} aria-labelledby={instructorsLabelId} />
            </div>
          </li>
        )}
      </ul>
    </section>
  );
}
